/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Absolute } from 'particles'
/* --------------------------- Styled Component ----------------------------- */
export default props => <Absolute {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Absolute/index.js